import { nonUndefined } from "Utility";
import { FsPrize } from "db/model/tournament/FsPrize";
import { Prize } from "model/Tournament/Prize";

export const mapPrizes = (fsModels: FsPrize[]) => {
  return nonUndefined(fsModels.map(mapPrize));
};

const mapPrize = (fsModel: FsPrize): Prize | undefined => {
  if (!fsModel.startPosition || !fsModel.prize) {
    return undefined;
  }

  return {
    startPosition: fsModel.startPosition,
    endPosition: fsModel.endPosition,
    prize: fsModel.prize,
  };
};
